/**
 * Save info to cookies.
 * @param key
 * @param value
 * @param rememberMe
 * @returns {null}
 */
export const addCookie = (key, value, rememberMe = false) => {
  try {
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);

    document.cookie = `${key}=${value}; expires=${
      rememberMe ? expirationDate.toUTCString() : 0
    }; path=/`;
  } catch (e) {
    return null;
  }
  return null;
};

/**
 * Delete cookie by key.
 * @param key
 * @returns {null}
 */
export const deleteCookie = key => {
  try {
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`;
  } catch (e) {
    return null;
  }
  return null;
};

/**
 * Get cookie by key.
 * @param key
 * @returns {*}
 */
export const getCookie = key => {
  try {
    return document.cookie
      ? document.cookie
          .split(';')
          .find(item => item.trim().split('=')[0] === key)
          .split('=')[1]
      : null;
  } catch (e) {
    return null;
  }
};
